import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

var PaginatorComponent = /** @class */ (function (_super) {
    __extends(PaginatorComponent, _super);
    function PaginatorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PaginatorComponent.prototype, "links", {
        get: function () {
            var _this = this;
            var prevPage = Math.max(this.currentPage - 1, 1);
            var nextPage = Math.min(this.currentPage + 1, this.totalPages);
            return [
                { icon: false, page: 1 },
                { icon: 'left-arrow', page: prevPage },
                { icon: false, page: this.currentPage },
                { icon: 'right-arrow', page: nextPage },
                { icon: false, page: this.totalPages },
            ].map(function (_a) {
                var icon = _a.icon, page = _a.page;
                return {
                    icon: icon,
                    page: page,
                    isEnabled: _this.currentPage !== page,
                    isCurrent: _this.currentPage === page,
                    link: _this.getPageLink(page),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    PaginatorComponent.prototype.getPageLink = function (page) {
        var _a, _b;
        if (this.link) {
            return __assign(__assign({}, ((_a = this.link) !== null && _a !== void 0 ? _a : {})), { params: __assign(__assign({}, ((_b = this.link.params) !== null && _b !== void 0 ? _b : {})), { page: page }) });
        }
        return null;
    };
    PaginatorComponent.prototype.setPage = function (page, event) {
        // Prevent routing if we do not pass through the link - this makes it optional to have
        // route based pagination.
        if (!this.link && event) {
            event.preventDefault();
        }
        return page;
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], PaginatorComponent.prototype, "currentPage", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], PaginatorComponent.prototype, "totalPages", void 0);
    __decorate([
        Prop({
            type: Object,
            required: false,
        }),
        __metadata("design:type", Object)
    ], PaginatorComponent.prototype, "link", void 0);
    __decorate([
        Emit('set-page'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Event]),
        __metadata("design:returntype", void 0)
    ], PaginatorComponent.prototype, "setPage", null);
    PaginatorComponent = __decorate([
        Component({
            name: 'ui-paginator',
        })
    ], PaginatorComponent);
    return PaginatorComponent;
}(Mixins(MagicConfigMixin)));

export default PaginatorComponent;
